const styles = {
  h1: { tag: "h1", base: "text-[48px] font-[700] text-[#1a1a1a] leading-[72px] text-center mb-[40px]" },
  h2: { tag: "h2", base: "text-[24px] font-[700] text-[#1a1a1a] leading-[32px] mb-[16px]" },
  h3: { tag: "h3", base: "text-[18px] font-[700] text-[#1a1a1a] leading-[30px] mb-[16px]" },
  "h3-bold": { tag: "h3", base: "text-[18px] font-[700] text-[#1a1a1a]" },
  p: { tag: "p", base: "text-[18px] leading-[30px] text-[#1a1a1a]", defaultMb: "mb-[16px]" },
  li: { tag: "li", base: "text-[18px] leading-[30px] text-[#1a1a1a]" },
  ul: { tag: "ul", base: "text-[18px] list-disc pl-5 space-y-1.5 mb-[16px]" },
  strong: { tag: "span", base: "font-bold text-[#1a1a1a]" },
  semibold: { tag: "span", base: "font-semibold text-[#1a1a1a]" },
};

/** Single typography component for legal pages.
 *  @param {string} variant - one of: h2 | h3 | h3-bold | p | li | ul | strong | semibold
 *  @param {string} [mb]    - overrides bottom margin for `p` variant (e.g. "mb-8", "mb-1", "")
 */
export default function Typo({ variant = "p", mb, children }) {
  const { tag: Tag, base, defaultMb = "" } = styles[variant];
  const mbClass = mb !== undefined ? mb : defaultMb;
  return <Tag className={`${base}${mbClass ? ` ${mbClass}` : ""}`}>{children}</Tag>;
}
